import { Logo } from '../../components/Logo'
import { useAuthContext } from '../../hooks/useAuthContext'
import copys from '../../utils/copys';
import IconArrowBack from '../../components/icons/IconArrowBack';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../utils/cn';

type HeaderProps = {
  customHeader?: string;
  backButtonCallback?: () => void;
  isMaintenance?: boolean;
}
export default function Header({ customHeader, backButtonCallback, isMaintenance }: HeaderProps) {

  const { userData } = useAuthContext();
  const navigate = useNavigate()

  if (customHeader) {
    return (
      <header className='flex gap-6 p-6 items-center'>
        <div id='buttonBackHeader' onClick={backButtonCallback ? backButtonCallback : () => navigate(-1)}>
          <IconArrowBack />
        </div>
        <div className='text-blue_text font-bold text-xl font-libre-franklin'>
          {customHeader}
        </div>
      </header>
    )
  } else {
    return (
      <header id='appHeader' className='flex bg-[#D4E5FF] items-center px-4 gap-8 py-2'>
        <Logo width={65} />
        <div className={cn('text-blue_text text-2xl font-libre-franklin', isMaintenance ? 'font-bold' : 'font-semibold')}>
          {
            !isMaintenance && (userData.isLogged ? 'Hola ' + userData.user?.name.split(' ')[0] : copys.screenHomeTitle)
          }
          {
            isMaintenance && copys.headerMaintenanceScreen
          }
        </div>
      </header>
    )
  }
}
